// removed by extract-text-webpack-plugin
module.exports = {"root":"info_root_2rnmgb","address":"info_address_9r2rj6","value":"info_value_38uakf","extraInfo":"info_extraInfo_4p6ovw"};


//////////////////
// WEBPACK FOOTER
// ./packages/page-index/src/transactions/transaction/info/info.scss
// module id = 592
// module chunks = 0